export default __webpack_public_path__ + "static/media/code_khfwxcx.62b8d535.jpg";